<div class="wrapper">
  <span class="title" [innerHTML]="title"></span>
  <p class="content">{{ content }}</p>
</div>